import { useFormContext } from 'react-hook-form';

import type { BlockedUserFormInput } from './blocked-user-form-schema';

export const useBlockedUserFormContext = useFormContext<BlockedUserFormInput>;
